import { Box, styled } from '@material-ui/core';

export const PageWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
});

export const ContentContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflow: 'auto',
});
